import { type AxiosPromise } from 'axios';

import { apiV1, armorAPI } from '~/services/api';

// TODO: Rename this to getManifestsToCreate or something similar getManifestableGroups?
// TODO: type params
// https://shippo.atlassian.net/browse/ENG-17605
const getManifestGroups = (dateRangeStart, dateRangeEnd, carrierObjectId) =>
  armorAPI.request({
    method: 'GET',
    params: {
      carrier_account_object_id: carrierObjectId,
      date_range_end: dateRangeEnd,
      date_range_start: dateRangeStart,
      is_test: false,
    },
    url: `/manifests/groups/`,
  });

// TODO: rename createManifest and type params
const generateManifest = (params) =>
  apiV1.request({
    data: {
      ...params,
      address_from: {
        ...params.address_from,
        country: params.address_from?.country?.iso2,
      },
    },
    method: 'POST',
    url: 'v1/manifests',
  });

const downloadManifestDocumentsZip = (manifestID: number): AxiosPromise<ArrayBuffer> =>
  armorAPI.request<ArrayBuffer>({
    method: 'GET',
    responseType: 'arraybuffer',
    url: `/manifests/documents/${manifestID}`,
  });

const getManifestsByObjectIds = (manifestObjectIds: string[]) =>
  armorAPI.request({
    method: 'GET',
    params: {
      manifests: manifestObjectIds,
    },
    url: '/manifests',
  });

/**
 *
 * @param dateRangeStart - RFC3339 formatted datetime string
 * @param dateRangeEnd - RFC3339 formatted datetime string
 */
const getManifestsByDateRange = (dateRangeStart: string, dateRangeEnd: string) =>
  armorAPI.request({
    method: 'GET',
    params: {
      date_range_end: dateRangeEnd,
      date_range_start: dateRangeStart,
    },
    url: '/manifests',
  });

export {
  downloadManifestDocumentsZip,
  generateManifest,
  getManifestGroups,
  getManifestsByDateRange,
  getManifestsByObjectIds,
};
